import { ViewEntity } from '../../types/entities/ViewEntity';
import { State } from '../../types/reducer/State';
import { View } from '../../types/view/View';

export function updateView<T extends ViewEntity>(
  state: State,
  newView: View<T>
): State {
  const index = state.user
    ? state.user.views.findIndex((oldView) => oldView.id === newView.id)
    : -1;
  return {
    ...state,
    user: state.user && {
      ...state.user,
      views: [
        ...state.user.views.slice(0, index),
        newView as View,
        ...state.user.views.slice(index + 1),
      ],
    },
  };
}
